module.exports = __webpack_public_path__ + "static/media/arrow.b934a8ce.svg";